<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Pengurangan' }" isRouteLink><font-awesome-icon
                  icon="fa-solid fa-chevron-left" /> Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <argon-button :to="{ name: 'Pengurangan' }" isRouteLink outline>Batalkan</argon-button>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Informasi Pengurangan">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Pengurangan" idinput="tingkatpermasalahan">
                    <InputForm type="text" v-model="data.tingkat_permasalahan" name="tingkat_permasalahan"
                      idinput="tingkatpermasalahan" placeholder="Silakan tulis tingkat permasalahan di sini" />
                  </form-group>

                  <form-group label="Nilai" idinput="nilai">
                    <InputForm type="number" v-model="data.nilai" name="nilai" idinput="tingkatpermasalahan"
                      placeholder="Nilai" step="0.01" />
                  </form-group>

                  <form-group label="Deskripsi" idinput="description">
                    <InputForm type="text" v-model="data.description" name="description" idinput="description" placeholder="Description" />
                  </form-group>

                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="active" v-model="data.status"
                        name="status" id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="inactive" v-model="data.status"
                        name="status" id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import PenguranganApi from "@/repository/api/PenguranganApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputForm from '@/components/InputForm.vue';


export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      data: {},
      unitKerja: [
        {}
      ],
      employee: [{}],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      jabatan: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputForm,
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
  },
  methods: {
    async submit() {
      this.$store.state.loading = true;
      if (this.$route.params.id) {
        await PenguranganApi.update(this.$route.params.id, this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Pengurangan" });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error.response.data.message,
            });
          });
        })
      }
      else {
        await PenguranganApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Pengurangan" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await PenguranganApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Pengurangan" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
